import { Trans, useTranslation } from "react-i18next";
import {
  ListItem,
  SectionContainer,
  SectionTitle,
} from "../PrivacyPolicyContent.styled";

export const DefinitionSectionContent = (props: DefinitionSectionContentProps) => {
  const { i18n } = useTranslation();

  return (
    <SectionContainer>
      <SectionTitle>
        <Trans i18nKey={"privacyPolicy.definition.title"} />
      </SectionTitle>
      <div>
        {(
          i18n.t("privacyPolicy.definition.definitions", {
            returnObjects: true,
          }) as string[]
        ).map((definition, index) => (
          <ListItem
            key={index}
            dangerouslySetInnerHTML={{ __html: definition }}
          />
        ))}
      </div>
    </SectionContainer>
  );
};

export interface DefinitionSectionContentProps {}
